const ModalTypes = {
    TOGGLE_REPRESENTATION_MODAL: 'TOGGLE_REPRESENTATION_MODAL',
    TOGGLE_FAQ_QUESTION: 'TOGGLE_FAQ_QUESTION',
    TOGGLE_FIRST_PIN : 'TOGGLE_FIRST_PIN'
};

export default ModalTypes;